import { EMPTY_STRING } from '@e-socna/empty';

export const rgbToHex = (r: number, g: number, b: number): string =>
  '#' +
  [r, g, b]
    .map((v) => Math.round(v).toString(16).padStart(2, '0'))
    .join(EMPTY_STRING);
